/* ============================================================
 * Tuff Tattoos — Measurement Event Layer  (tuff-events.js)
 * Phase 2 · v1.1
 * ------------------------------------------------------------
 * v1.1 (2026-09-23):
 *  - FIX: init-time events (artist_page_viewed,
 *    booking_confirmation_viewed) were pushed into dataLayer
 *    before the Google tag's config commands and were dropped
 *    (gtag discards events queued ahead of any config). They now
 *    wait for the tag to initialize (window.google_tag_manager),
 *    retrying for up to 10s, then send regardless.
 *  - Click IDs: wbraid/gbraid now also map src -> 'google'
 *    (previously only gclid did).
 *  - Roster: + terrero, tiko.
 * Design rules:
 *  - No PII is ever read or sent (no names/emails/phones/free text).
 *  - Every event answers a business question; params over event sprawl.
 *  - Defensive: every handler wrapped; failure = silence, never breakage.
 * ============================================================ */
(function () {
  'use strict';
  if (window.__tuffEvents) return; window.__tuffEvents = 1;

  /* gtag shim: if the Google tag hasn't defined gtag yet (script order
     varies), queue into dataLayer directly — GA4 replays it on config. */
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function(){ window.dataLayer.push(arguments); };
  }

  /* ---------- config ---------------------------------------- */
  /* RESERVED NAME — do not use for anything else:
     'booking_request_submitted' is reserved for a deterministic TRUE
     KTF request-creation signal (candidate: KTF's native GA integration,
     pending the controlled test). The thank-you page does NOT qualify:
     it fires 'booking_confirmation_viewed' below, a diagnostic event. */
  var ADS_SEND_TO = '';            /* intentionally unused for the confirmation
                                      event; will belong to the future TRUE
                                      booking_request_submitted only */
  var BREAKOUT_ON_THANKYOU = true; /* framed thank-you promotes itself to the top
                                      window (same-origin nav) — fixes UX + keeps
                                      the session's original source intact */
  var ARTISTS = { ally:'Ally', tiago:'Tiago', dido:'Dido', brandon:'Brandon',
                  carlos:'Carlos', 'nick-1':'Nick', kim:'Kim',
                  terrero:'Terrero', tiko:'Tiko' };
  var SERVICE_PAGES = ['custom-tattoos','realism-color','fine-line-micro','floral-mandala',
    'black-grey-blackwork','cover-ups','large-scale-sleeves','guest-artists','services'];

  /* ---------- helpers --------------------------------------- */
  function safe(fn){ return function(){ try { return fn.apply(this, arguments); } catch(e){} }; }
  function send(name, params){
    try {
      params = params || {};
      params.page_type = params.page_type || pageType();
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      if (typeof window.fbq === 'function' && params.__fb) {
        window.fbq(params.__fb === 'Lead' ? 'track' : 'trackCustom',
                   params.__fb === 'Lead' ? 'Lead' : name, {});
      }
      delete params.__fb;
    } catch(e){}
  }
  /* v1.1: for events fired at script-init time. gtag drops events queued
     before any config command, so wait until the Google tag has
     initialized (config processed) before sending. Falls back to a
     plain send after ~10s so no event is ever lost silently. */
  function sendWhenReady(name, params, tries){
    tries = tries || 0;
    if (window.google_tag_manager || tries > 40) { send(name, params); return; }
    setTimeout(function(){ sendWhenReady(name, params, tries + 1); }, 250);
  }
  function handle(){ var m = location.pathname.match(/^\/pages\/([a-z0-9-]+)/); return m ? m[1] : null; }
  function artistFromPath(){ var h = handle(); return h && ARTISTS[h] ? ARTISTS[h] : null; }
  function pageType(){
    var p = location.pathname, h = handle();
    if (p === '/' ) return 'home';
    if (h && ARTISTS[h]) return 'artist';
    if (h === 'book') return 'book';
    if (h === 'thank-you') return 'thank_you';
    if (h === 'gallery') return 'gallery';
    if (h && SERVICE_PAGES.indexOf(h) > -1) return 'service';
    if (p.indexOf('/blogs/') === 0) return 'blog';
    return h ? 'page' : 'other';
  }
  function sectionOf(el){
    var s = el.closest && el.closest('.shopify-section');
    if (!s) return 'other';
    var c = s.className || '';
    if (/header/.test(c)) return 'header';
    var inner = s.querySelector('[class*="hero"]') ? 'hero' : null;
    if (el.closest('.tuff-mobile-bar,[class*="mobile-bar"]')) return 'mobile_bar';
    if (el.closest('footer')) return 'footer';
    if (s.querySelector('.artist-profile,[class*="artist-profile"]')) return 'artist_profile';
    if (/cta/.test(c) || s.querySelector('[class*="cta-centered"]')) return 'cta_band';
    return inner || 'content';
  }

  /* ---------- first-touch attribution capture ---------------- */
  /* First-party, 180-day cookie. IDs only — no PII. Used later to
     stamp booking_confirmation_viewed and (pending KTF capability
     verification) to hand attribution into the booking record.   */
  var ATTR_COOKIE = '_tuff_attr';
  function readCookie(n){
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null;
  }
  var firstTouch = null;
  safe(function(){
    firstTouch = JSON.parse(readCookie(ATTR_COOKIE) || 'null');
    if (!firstTouch) {
      var q = new URLSearchParams(location.search);
      var ref = document.referrer || '';
      var refHost = ''; try { refHost = ref ? new URL(ref).hostname : ''; } catch(e){}
      var internal = /(^|\.)tufftattoos\.com$/.test(refHost) || /keepthefees\.com$/.test(refHost);
      var adClick = q.get('gclid') || q.get('wbraid') || q.get('gbraid');
      firstTouch = {
        src:  q.get('utm_source')   || (internal ? null : (refHost || null)) || (adClick ? 'google' : null) || 'direct',
        med:  q.get('utm_medium')   || (adClick ? 'cpc'
              : (refHost && !internal ? 'referral' : 'none')),
        cmp:  q.get('utm_campaign') || null,
        cnt:  q.get('utm_content')  || null,
        gclid:  q.get('gclid')  || null,
        wbraid: q.get('wbraid') || null,
        gbraid: q.get('gbraid') || null,
        fbclid: q.get('fbclid') || null,
        lp: location.pathname.slice(0, 120),
        ts: Date.now()
      };
      var v = encodeURIComponent(JSON.stringify(firstTouch));
      document.cookie = ATTR_COOKIE + '=' + v + ';path=/;max-age=' + (180*86400) + ';domain=.tufftattoos.com;SameSite=Lax;Secure';
    }
  })();
  function attrParams(){
    if (!firstTouch) return {};
    return { ft_source: firstTouch.src, ft_medium: firstTouch.med,
             ft_campaign: firstTouch.cmp || '(none)', ft_landing: firstTouch.lp };
  }

  /* ---------- thank-you: booking_confirmation_viewed ---------- */
  /* DIAGNOSTIC event, deliberately NOT named booking_request_submitted.
     Proven 2026-09-22: this page is reached only by STANDALONE-form
     users who tap KTF's post-submit Continue (~50/mo of ~245 true
     requests); the embedded flow is frame-blocked and never arrives.
     It marks "a submitter chose to continue", carries attribution for
     the sessions it can see, and is NOT a conversion anywhere — no
     GA4 key event, no Ads send, no Meta Lead. The KTF API is the
     authoritative request count.                                   */
  if (pageType() === 'thank_you') {
    var FRAMED = (function(){ try { return window.self !== window.top; } catch(e){ return true; } })();
    if (FRAMED && BREAKOUT_ON_THANKYOU) {
      /* Defensive only — frame-ancestors currently prevents framed
         loads entirely; harmless no-op unless that ever changes.    */
      safe(function(){ window.top.location.replace(location.href); })();
    }
    safe(function(){
      if (FRAMED && BREAKOUT_ON_THANKYOU) return;
      if (sessionStorage.getItem('tuff_bcv')) return;
      sessionStorage.setItem('tuff_bcv','1');
      var p = attrParams();
      p.booking_entry_point = readCookie('_tuff_bep') || 'unknown';
      p.page_type = 'thank_you';
      sendWhenReady('booking_confirmation_viewed', p);
    })();
  }

  /* ---------- artist page view -------------------------------- */
  safe(function(){
    var a = artistFromPath();
    if (a) sendWhenReady('artist_page_viewed', { artist: a, page_type: 'artist' });
  })();

  /* ---------- click delegation -------------------------------- */
  document.addEventListener('click', safe(function(ev){
    var el = ev.target && ev.target.closest ? ev.target.closest('a,button') : null;
    if (!el) return;
    var href = el.getAttribute && (el.getAttribute('href') || '');

    /* Book CTA — any link into /pages/book */
    if (href && href.indexOf('/pages/book') > -1) {
      var a = artistFromPath();
      var loc = sectionOf(el);
      var bep = (a ? 'artist:' + a : 'page:' + pageType()) + '|' + loc;
      document.cookie = '_tuff_bep=' + encodeURIComponent(bep) + ';path=/;max-age=7200;SameSite=Lax;Secure';
      send('book_cta_clicked', { cta_location: loc, artist: a || '(none)',
        cta_text: (el.textContent||'').trim().slice(0,40) });
      return;
    }
    if (href && href.indexOf('tel:') === 0)   { send('phone_clicked',  { link_location: sectionOf(el) }); return; }
    if (href && href.indexOf('mailto:') === 0){ send('email_clicked',  { link_location: sectionOf(el) }); return; }
    if (href && /maps\.google|google\.[a-z.]+\/maps|maps\.apple/.test(href)) {
      send('directions_clicked', { link_location: sectionOf(el) }); return;
    }
    if (href && /instagram\.com/.test(href)) {
      send('instagram_clicked', { artist: artistFromPath() || '(studio)', link_location: sectionOf(el) }); return;
    }
    /* Portfolio engagement: gallery filter chips + gallery/work images */
    var fbtn = ev.target.closest && ev.target.closest('[data-filter]');
    if (fbtn) { send('artist_portfolio_engaged', { engagement_type:'filter',
      filter_value:(fbtn.getAttribute('data-filter')||'').slice(0,40) }); return; }
    var piece = ev.target.closest && ev.target.closest('[data-tags]');
    if (piece) {
      var tags = (piece.getAttribute('data-tags')||'').split('|');
      send('artist_portfolio_engaged', { engagement_type:'piece',
        artist: tags[0] ? tags[0].charAt(0).toUpperCase()+tags[0].slice(1) : '(unknown)' });
      return;
    }
  }), { capture: true, passive: true });

  /* ---------- contact form ----------------------------------- */
  safe(function(){
    var form = document.querySelector('form[action*="/contact"]');
    if (!form) return;
    var started = false;
    form.addEventListener('focusin', safe(function(){
      if (started) return; started = true;
      send('contact_form_started', {});
    }));
    form.addEventListener('submit', safe(function(){
      send('contact_form_submitted', { note: 'submitted_not_confirmed' });
    }));
  })();

  /* ---------- booking form engagement (labeled proxy) --------- */
  /* First focus transfer into the cross-origin KTF iframe. This is
     an ENGAGED proxy, not "form started" — the iframe is opaque.  */
  safe(function(){
    var fired = false;
    window.addEventListener('blur', safe(function(){
      if (fired) return;
      var ae = document.activeElement;
      if (ae && ae.tagName === 'IFRAME' && /keepthefees/.test(ae.src || '')) {
        fired = true;
        send('booking_form_engaged', { note: 'proxy_iframe_focus' });
      }
    }));
  })();
})();
